<template>
  <div class="container">
    <div class="not-authorized">
      <div class="no-access-logo">
        <lottie-animation
          ref="anim"
          :animationData="require('@/assets/icons/animations/not-authorized.json')"
          :loop="true"
          :style="'height: 590px'"
        />
      </div>
      <div class="no-access-message">
        <div> {{ $t('unprivileged.user.authorisation.required.1') }} </div>
        <div class="no-access-message-highlight">{{ $t('unprivileged.user.authorisation.required.2') }}</div>
        <div>{{ $t('unprivileged.user.authorisation.required.3') }}</div> <br/>
      </div>
      <div class="no-access-message second-line">
        {{ $t('unprivileged.user.contact.admin') }}
      </div>
    </div>
  </div>
</template>

<script>

import LottieAnimation from 'lottie-web-vue';

export default {
  name: 'NotAuthorized',
  components: {
    LottieAnimation,
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/design-system';

.container{
  display: flex;
  justify-content: center;
  background-color: var(--bg-secondary);
  height: 100%;
}
.not-authorized {
  display: flex;
  flex-direction:column;
  height: 100%;
  background-color: var(--bg-secondary);
}
.no-access-logo{
  display: flex;
  justify-content: center;
  padding-top: rem(100);
  img {
    height: rem(300);
  }
}
.no-access-message{
  padding-top: rem(50);
  display: flex;
  font-family: $font-family-black;
  font-size: rem(20);
  color: var(--text-tertiary);
  text-align: center;
  justify-content: center;
  &-highlight{
    color: var(--status-error);
  }
  div{
    padding-left: rem(5);
  }
}
.second-line{
  padding-top: rem(10);
}
</style>
